import * as PropTypes from 'prop-types';
import * as React from 'react';
import formatAmount from '../../../shared/format_amount';
import Money from '../../../shared/money';

class Product extends React.Component {
  get hasPriceDifference() {
    return this.offeredPrice && (this.offeredPrice.cents !== this.listingPrice.cents);
  }

  get offeredPrice() {
    let price;

    try {
      price = Money.parse(this.props.initialOfferPrice, this.props.product.listing_currency);
    } catch (ex) {
      price = null;
    }

    return price;
  }

  get listingPrice() {
    return Money.parse(this.props.product.price.amount, this.props.product.listing_currency);
  }

  renderCost() {
    if (!this.props.product.seller_cost) {
      return null;
    }

    return (
      <p className="color-gray mb-0">
        {
          I18n.t(
            'js.productBundles.productDetails.sellerCost',
            { cost: formatAmount(this.props.product.seller_cost) },
          )
        }
      </p>
    );
  }

  renderSku() {
    if (!this.props.product.sku) {
      return null;
    }
    return (
      <div className="color-gray">
        {I18n.t('js.productBundles.productDetails.sku', { sku: this.props.product.sku })}
      </div>
    );
  }

  renderPrices() {
    if (!this.hasPriceDifference) {
      return (<h4 className="strong color-gray">{formatAmount(this.props.product.price)}</h4>);
    }

    return (
      <div>
        <h4 className="color-gray line-through">{formatAmount(this.props.product.price)}</h4>
        <h4 className="color-gray weight-bold">
          {formatAmount({
            amount: this.props.initialOfferPrice,
            symbol: this.props.product.price.symbol,
          })}
        </h4>
      </div>
    );
  }

  render() {
    return (
      <div className="g-container">
        <div className="g-col-2">
          <img
            className="img-wide bd-1 bd--offwhite"
            alt={this.props.product.title}
            src={this.props.product._links.photo.href}
          />
        </div>
        <div className="g-col-8">
          <h4 className="strong color-gray">{this.props.product.title}</h4>
          {this.renderSku()}
          <div className="color-gray">
            {
              I18n.t(
                'js.productBundles.productDetails.condition',
                {
                  condition: this.props.product.condition.display_name,
                },
              )
            }
          </div>
          {this.renderCost()}
        </div>
        <div className="g-col-2 align-right">
          {this.renderPrices()}
        </div>
      </div>
    );
  }
}

Product.propTypes = {
  product: PropTypes.object.isRequired,
  initialOfferPrice: PropTypes.string,
};

export default Product;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/email_offers/product.jsx